import {
    CREATE_EVENT,
    DELETE_EVENT,
    DESELECT_EVENT,
    GET_ALL_EVENTS,
    GET_EVENT_BY_ID,
    GET_SHARED_WITH,
    UPDATE_EVENT,
    LOADING_EVENT,
    GET_EVENT_SHARED_WITH_ME,
    LOADING_SHARED_WITH_ME,
    ANNOUNCE_EVENT_COMPLETE,
    SET_PUBLIC_GALLERY,
    LOADING_PUBLIC_GALLERY,
    SIGN_OUT
} from "../actions/type";

const initialState = {
    events: [],
    eventSharedWithMe: [],
    selectedEvent: {},
    loading: false,
    loadingSharedWithMe: false,
    loadingPublicGallery: false,
    eventsFetched: false,
    sharedFetched: false
};

const eventsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_EVENTS:
            return {
                ...state,
                events: payload.Data,
                eventsFetched: true
            };
        case GET_EVENT_SHARED_WITH_ME:
            return {
                ...state,
                eventSharedWithMe: payload,
                sharedFetched: true
            };
        case CREATE_EVENT:
            return {
                ...state,
                events: [...state.events, payload],
                selectedEvent: payload
            };
        case UPDATE_EVENT:
            const indexToUpdate = state.events.findIndex(e => e.id === payload.Data.id);
            return {
                ...state,
                events: [
                    ...state.events.slice(0, indexToUpdate),
                    payload.Data,
                    ...state.events.slice(indexToUpdate + 1)
                ],
                selectedEvent: payload.Data
            };
        case ANNOUNCE_EVENT_COMPLETE:
            const announced = {
                completed: payload.completed,
                completedDate: payload.completedDate,
                lastNoticeDate: payload.lastNoticeDate
            };
            return {
                ...state,
                events: state.events.map(e => e.id === payload.id ? { ...e, ...announced } : e),
                selectedEvent: state.selectedEvent?.id === payload.id
                    ? { ...state.selectedEvent, ...announced }
                    : state.selectedEvent
            };
        case SET_PUBLIC_GALLERY:
            const gallery = {
                publicGalleryActive: payload.publicGalleryActive,
                publicPosterWarning: payload.publicPosterWarning
            };
            return {
                ...state,
                events: state.events.map(e => e.id === payload.id ? { ...e, ...gallery } : e),
                selectedEvent: state.selectedEvent?.id === payload.id
                    ? { ...state.selectedEvent, ...gallery }
                    : state.selectedEvent
            };
        case LOADING_PUBLIC_GALLERY:
            return {
                ...state,
                loadingPublicGallery: payload
            };
        case GET_EVENT_BY_ID:
            let event = state.events.find(e => e.id === payload);
            return {
                ...state,
                selectedEvent: event
            };
        case GET_SHARED_WITH:
            return {
                ...state,
                selectedEvent: {
                    ...state.selectedEvent,
                    sharedWith: payload
                }
            };
        case DESELECT_EVENT:
            return {
                ...state,
                selectedEvent: {}
            };
        case DELETE_EVENT:
            const indexToDelete = state.events.findIndex(e => e.id === payload);
            return {
                ...state,
                events: [
                    ...state.events.slice(0, indexToDelete),
                    ...state.events.slice(indexToDelete + 1)
                ],
                selectedEvent: {}
            };
        case LOADING_EVENT:
            return {
                ...state,
                loading: payload
            };
        case LOADING_SHARED_WITH_ME:
            return {
                ...state,
                loadingSharedWithMe: payload,
                // El `finally` de la accion lo baja tanto al llegar los datos como al fallar:
                // una llamada resuelta con error tambien deja de ser primera carga.
                sharedFetched: state.sharedFetched || !payload
            };
        case SIGN_OUT:
            return {
                ...state,
                events: [],
                eventSharedWithMe: [],
                selectedEvent: {},
                eventsFetched: false,
                sharedFetched: false
            };
        default:
            return state;
    }
};

export default eventsReducer;
